// extracted by mini-css-extract-plugin
export var printerCard = "_by-1";
export var printerCardConfigured = "_by-2";
export var printerCardError = "_by-3";
export var printerCardsContainer = "_by-0";
export var printerIcon = "_by-8";
export var printerIconConfigured = "_by-5";
export var printerIconContainer = "_by-4";
export var printerIconError = "_by-6";
export var printerIconUnconfigured = "_by-7";
export var workstationsTableCard = "_by-9";